<template>
  <div class="home">
    <!-- 首页顶部-->
    <div class="header" id="top">
      <video autoplay loop muted playsinline>
        <source src="../assets/bg.mp4" type="video/mp4" />
      </video>
      <div class="greeting">
        <div style="margin-top: 10vh; width: 50%; text-align: center">
          <h1 ref="text" class="msg"></h1>
        </div>
      </div>
      <svg
        class="WaveMultiGroup"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
        shape-rendering="auto"
      >
        <path
          fill="rgba(255,255,255,0.7)"
          d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
        ></path>
        <path
          fill="rgba(255,255,255,0.5)"
          d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
        ></path>
        <path
          fill="rgba(255,255,255,0.3)"
          d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
        ></path>
        <path
          fill="rgba(255,255,255,1)"
          d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
        ></path>
      </svg>
    </div>

    <!-- 侧边导航 -->
    <div :class="{ hidden: !isVisible }" class="side-menu-div">
      <SideMenu></SideMenu>
    </div>

    <!-- 主体内容 -->
    <div class="footprint-div">
      <div class="title" id="footprint">
        <label class="linear-gradient-text">👣 足 迹 </label><br /><br />
        <label class="desc" ref="title1"></label>
      </div>
      <TimeLine></TimeLine>
    </div>

    <div style="margin: 10vh 10vw">
      <div class="title" id="collection">
        <label class="linear-gradient-text">🌸 撷 英 </label><br /><br />
        <label class="desc" ref="title2"></label>
      </div>
      <ShowCase></ShowCase>
    </div>

    <div style="margin: 10vh 10vw">
      <div class="title" id="writing">
        <label class="linear-gradient-text">💡 省 思 </label><br /><br />
        <label class="desc" ref="title3"> </label>
      </div>
      <el-row>
        <el-col
          v-for="(item, index) in blogContent"
          :key="item"
          :span="writingSpan"
          :offset="writingSpan === 6 ? (index % 3 !== 0 ? 1 : 2) : 2"
        >
          <a
            :href="item.turnRoute"
            target="_blank"
            style="text-decoration: none"
          >
            <el-card
              shadow="hover"
              :body-style="{ padding: '5px' }"
              style="margin-bottom: 5vh"
            >
              <img :src="item.picPath" class="image" :alt="item.text" />
              <div style="padding-bottom: 14px; text-align: center">
                <h4>{{ item.text }}</h4>
              </div>
            </el-card>
          </a>
        </el-col>
      </el-row>
    </div>
    <!--  <config-provider></config-provider>-->
    <audio autoplay loop hidden ref="bgaudio">
      <source src="../assets/bg.mp3" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script setup lang="ts">
import SideMenu from "@/components/SideMenu.vue";
import TimeLine from "@/components/TimeLine.vue";
import ShowCase from "@/components/ShowCase.vue";
import { onMounted, onUnmounted, ref } from "vue";
import TypeIt from "typeit";

const text = ref("");
const title1 = ref("");
const title2 = ref("");
const title3 = ref("");
const isVisible = ref(true);
let timeoutId: number | null | undefined = null;

const hideMenu = () => {
  isVisible.value = false;
};

const showMenu = () => {
  isVisible.value = true;
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
  timeoutId = setTimeout(hideMenu, 5000);
};

const handleScroll = () => {
  showMenu();
};
const blogContent = [
  {
    picPath: require("../assets/suzime.jpeg"),
    text: "荧幕后的万千世界",
    turnRoute: "https://v6bn1welpm.feishu.cn/docx/Dh2cdd1iOoLvzhxnJJBcq4XqnDI",
  },
  {
    picPath: require("../assets/atk.jpg"),
    text: "人类从历史中学到的",
    turnRoute: "https://www.bilibili.com/video/BV1494y1e7bV",
  },
  {
    picPath: require("../assets/cover.png"),
    text: "Research Page",
    turnRoute: "#/research",
  },
];
onMounted(() => {
  new TypeIt(text.value, {
    speed: 150,
    deleteSpeed: 50,
    cursorChar: "<span class='cursorChar'>|<span>", //用于光标的字符。HTML也可以
    lifeLike: true, // 使打字速度不规则
    cursor: false, //在字符串末尾显示闪烁的光标
    breakLines: false, // 控制是将多个字符串打印在彼此之上，还是删除这些字符串并相互替换
    loop: true, //是否循环
  })
    .type("欢迎来到邵国诚的个人网站！", { delay: 2000 })
    .delete("", { delay: 1000 })
    .type("点击任意位置以启用背景音乐~", { delay: 2000 })
    .delete("", { delay: 12000 })
    .go();

  new TypeIt(title1.value, {
    speed: 150,
    deleteSpeed: 50,
    lifeLike: true,
    loop: true,
  })
    .type("旅程总有一天会迎来终点，所以，不必匆忙", { delay: 5000 })
    .delete("", { delay: 2000 })
    .type("风带来故事的种子，时间使之发芽", { delay: 5000 })
    .delete("", { delay: 2000 })
    .go();

  new TypeIt(title2.value, {
    speed: 150,
    deleteSpeed: 50,
    lifeLike: true,
    loop: true,
  })
    .type("旅人将遍历的一万个故事，都将成为旅人灵魂的一部分", { delay: 5000 })
    .delete("", { delay: 2000 })
    .type("所谓的平凡生活，其实是日复一日的奇迹", { delay: 5000 })
    .delete("", { delay: 2000 })
    .type(
      "就算命运是注定的，人在路途中能做的事仍然有很多，而故事的结局也会呈现截然不同的意义",
      { delay: 5000 }
    )
    .delete("", { delay: 2000 })
    .type("岁月流转，唯有思念与归风不变", { delay: 5000 })
    .delete("", { delay: 2000 })
    .go();

  new TypeIt(title3.value, {
    speed: 150,
    deleteSpeed: 50,
    lifeLike: true,
    loop: true,
  })
    .type("艺术，让人成为人", { delay: 5000 })
    .delete("", { delay: 2000 })
    .type("信息熵即为灵魂", { delay: 5000 })
    .delete("", { delay: 2000 })
    .go();
});

const bgaudio = ref();
const playAudio = () => {
  if (bgaudio.value && bgaudio.value.paused) {
    bgaudio.value.play();
  }
};

const writingSpan = ref(6);

const updateWritingSpan = () => {
  if (window.innerWidth <= 768) {
    writingSpan.value = 20;
  } else {
    writingSpan.value = 6;
  }
};
onMounted(() => {
  // 目前许多浏览器不允许自动播放音频，只有用户点击屏幕后才可以播放
  document.addEventListener("click", playAudio);
  window.addEventListener("scroll", handleScroll);
  updateWritingSpan();
  window.addEventListener("resize", updateWritingSpan);
});

onUnmounted(() => {
  document.removeEventListener("click", playAudio);
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("resize", updateWritingSpan);
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
});
</script>

<style scoped>
/* 背景 */
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  //position: relative;
  width: 100%;
  height: 100vh; /* Adjust height as needed */
  overflow: hidden;
  /*background: linear-gradient(60deg,rgba(84,58,183,1) 0%, rgba(0,172,193,1) 100%);*/
}

.header video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100vh;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.greeting {
  height: 88vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  fill: #1b1f23;
  z-index: 1;
}

.greeting .msg {
  color: white;
  font-size: 2em;
  font-family: Microsoft YaHei UI Light, 宋体, sans-serif;
  margin: -10vh auto auto auto;
  text-shadow: 1px 1px 0 #0096ff, -1px 1px 0 #0096ff, 1px -1px 0 #0096ff,
    -1px -1px 0 #0096ff, 1px 0 0 #0096ff, -1px 0 0 #0096ff, 0 1px 0 #0096ff,
    0 -1px 0 #0096ff;
}

@media (max-width: 768px) {
  .greeting .msg {
    font-size: 1em;
  }
}

.WaveMultiGroup {
  position: relative;
  width: 100%;
  height: 12vh;
  margin-bottom: 0;
  min-height: 8vh;
  max-height: 20vh;
}

@media (max-width: 768px) {
  .WaveMultiGroup {
    height: 16vh;
  }
}

.WaveMultiGroup path {
  animation: multiwavemove 30s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
}

.WaveMultiGroup path:nth-child(1) {
  transform: translateY(0px);
  animation-delay: -2s;
  animation-duration: 7s;
}

.WaveMultiGroup path:nth-child(2) {
  transform: translateY(1px);
  animation-delay: -3s;
  animation-duration: 10s;
}

.WaveMultiGroup path:nth-child(3) {
  transform: translateY(2px);
  animation-delay: -4s;
  animation-duration: 13s;
}

.WaveMultiGroup path:nth-child(4) {
  transform: translateY(3px);
  animation-delay: -5s;
  animation-duration: 20s;
}

@keyframes multiwavemove {
  0% {
    transform: translate3d(-30px, 0, 0);
  }
  60% {
    transform: translate3d(80px, 0, 0);
  }
  100% {
    transform: translate3d(-30px, 0, 0);
  }
}

.side-menu-div {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
  border-radius: 20px;
  transition: opacity 0.5s ease-in-out;
  will-change: opacity, transform;
}

.side-menu-div.hidden {
  opacity: 0;
  pointer-events: none; /* Prevents interaction when hidden */
}

.footprint-div {
  margin: auto 25vw;
}

@media (max-width: 768px) {
  .footprint-div {
    margin: auto 5vw;
  }
}

.image {
  display: block;
  width: 90%;
  margin: 10px 5%;
}

blockquote {
  font-style: italic;
  font-size: 20px;
  font-weight: 450;
  line-height: 1.5;
  opacity: 1;
  color: hsla(0, 0%, 100%, 0.9);
}

.icon .btn {
  height: 0.26rem;
  margin-left: 0.26rem;
  cursor: pointer;
  position: relative;
}

.linear-gradient-text {
  font-size: 3em;
  font-family: "Microsoft YaHei UI Light", sans-serif;
  margin-bottom: 500px;
  background: linear-gradient(
    125deg,
    rgb(243, 95, 178) 0%,
    rgb(16, 199, 248) 50%,
    rgb(243, 95, 178) 100%
  );
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradient-flow 5s linear infinite;
}

@media (max-width: 768px) {
  .linear-gradient-text {
    font-size: 2em;
  }
}

@keyframes gradient-flow {
  0% {
    background-position: 0 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}

.desc {
  margin: 0 auto;
  font-size: 1em;
  letter-spacing: 5px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}

@media (max-width: 768px) {
  .desc {
    font-size: 0.8em;
    letter-spacing: 2px;
  }
}

.title {
  text-align: center;
  margin-bottom: 30px;
}
</style>
